import React, { useReducer } from 'react';
import AuthContext from './authContext'
import AuthReducer from './authReducer'

import Swal from 'sweetalert2';

import clienteAxios from '../../config/axios'
import tokenAuth from '../../config/tokenAuth'

import { 
    REGISTRO_EXITOSO,
    REGISTRO_ERROR,
    OBTENER_USUARIO,
    CARGANDO_LOGIN,
    LOGIN_EXITOSO,
    LOGIN_ERROR,
    CERRAR_SESION,
    OCULTAR_MENSAJE_ALERTA
} from '../../types';

const AuthState = ({children}) => {

    const initialState = {
        token: localStorage.getItem('token'),
        autenticado: null,
        usuario: null,
        mensaje: null,
        cargando: true,
        cargandologin: false
    }

    const [ state, dispatch ] = useReducer(AuthReducer, initialState);

    // Las funciones
    const registrarUsuario = async datos => {
        try {
            const respuesta = await clienteAxios.post('/api/usuarios', datos);

            const alerta = {
                msg: respuesta.data.msg,
                categoria: 'alerta-ok',
                lugar: 'cuenta'
            };
            
            dispatch({
                type: REGISTRO_EXITOSO,
                payload: alerta
            });

            Swal.fire({
                title: '¡Agregada!',
                text: respuesta.data.msg,
                icon: 'success',
                confirmButtonColor: '#2f3848'
            });
            
            setTimeout(() => {
                dispatch({
                    type: OCULTAR_MENSAJE_ALERTA
                })
            }, 1000);
        } catch (error) {
            const alerta = {
                msg: error.response.data.msg,
                categoria: 'alerta-error',
                lugar: 'cuenta'
            };

            dispatch({
                type: REGISTRO_ERROR,
                payload: alerta
            });
            
            // Despues de 5 segundos limpiar la alerta
            setTimeout(() => {
                dispatch({
                    type: OCULTAR_MENSAJE_ALERTA
                })
            }, 5000);
        }
    }

    // Retorna el usuario autenticado
    const usuarioAutenticado = async () => {
        const token = localStorage.getItem('token');
        if(token) {
            tokenAuth(token);
        }

        try {
            const respuesta = await clienteAxios.get('/api/auth');
            dispatch({
                type: OBTENER_USUARIO,
                payload: respuesta.data.usuario
            });
        } catch (error) {
            dispatch({
                type: LOGIN_ERROR
            });
        }
    }

    // Cuando el usuario inicia sesión
    const iniciarSesion = async datos => {
        dispatch({
            type: CARGANDO_LOGIN
        });

        try {
            const respuesta = await clienteAxios.post('/api/auth', datos);
            
            dispatch({
                type: LOGIN_EXITOSO,
                payload: respuesta.data
            });

            // Obtener usuario
            usuarioAutenticado();
        } catch (error) {
            const alerta = {
                msg: !error.response.data.msg ? (
                    error.response.data.errores.map(error => (error.msg))
                ) : (
                    error.response.data.msg
                ) ,
                categoria: 'alerta-error',
                lugar: 'cuenta'
            };

            dispatch({
                type: LOGIN_ERROR,
                payload: alerta
            });

            // Despues de 5 segundos limpiar la alerta
            setTimeout(() => {
                dispatch({
                    type: OCULTAR_MENSAJE_ALERTA
                })
            }, 5000);
        }
    }

    // Cierra la sesión del usuario
    const cerrarSesion = () => {
        dispatch({
            type: CERRAR_SESION
        });
    }

    return (
        <AuthContext.Provider
            value={{
                token: state.token,
                autenticado: state.autenticado,
                usuario: state.usuario,
                mensaje: state.mensaje,
                cargando: state.cargando,
                cargandologin: state.cargandologin,
                registrarUsuario,
                usuarioAutenticado,
                iniciarSesion,
                cerrarSesion
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthState;